function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = function __commonJS(cb, mod) {
    return function __require() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var __copyProps = function __copyProps(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : _type_of(from)) === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function get() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
    "../../node_modules/classnames/index.js": function(exports, module) {
        "use strict";
        (function() {
            "use strict";
            var hasOwn = {}.hasOwnProperty;
            var nativeCodeString = "[native code]";
            function classNames2() {
                var classes = [];
                for(var i = 0; i < arguments.length; i++){
                    var arg = arguments[i];
                    if (!arg) continue;
                    var argType = typeof arg === "undefined" ? "undefined" : _type_of(arg);
                    if (argType === "string" || argType === "number") {
                        classes.push(arg);
                    } else if (Array.isArray(arg)) {
                        if (arg.length) {
                            var inner = classNames2.apply(null, arg);
                            if (inner) {
                                classes.push(inner);
                            }
                        }
                    } else if (argType === "object") {
                        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                            classes.push(arg.toString());
                            continue;
                        }
                        for(var key in arg){
                            if (hasOwn.call(arg, key) && arg[key]) {
                                classes.push(key);
                            }
                        }
                    }
                }
                return classes.join(" ");
            }
            if (typeof module !== "undefined" && module.exports) {
                classNames2.default = classNames2;
                module.exports = classNames2;
            } else if (typeof define === "function" && _type_of(define.amd) === "object" && define.amd) {
                define("classnames", [], function() {
                    return classNames2;
                });
            } else {
                window.classNames = classNames2;
            }
        })();
    }
});
// Countdown/CountdownDigits.tsx
var import_classnames = __toESM(require_classnames());
import React from "react";
var CountdownDigits = function CountdownDigits(param) {
    var className = param.className, digitClassName = param.digitClassName, renderLabel = param.renderLabel, _param_showHours = param.showHours, showHours = _param_showHours === void 0 ? true : _param_showHours, timeLeft = param.timeLeft;
    var digit = function digit(segment, label, value) {
        return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", {
            "aria-label": label,
            className: digitClassName,
            "data-testid": "countdown-".concat(segment)
        }, value), renderLabel === null || renderLabel === void 0 ? void 0 : renderLabel(segment));
    };
    var separator = /* @__PURE__ */ React.createElement("span", {
        className: digitClassName,
        "data-testid": "countdown-separator"
    }, ":");
    return /* @__PURE__ */ React.createElement("div", {
        className: (0, import_classnames.default)("flex flex-row", className),
        "data-testid": "countdown-digits"
    }, showHours && /* @__PURE__ */ React.createElement(React.Fragment, null, digit("hours", "Hours left", timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.hoursLeft), separator), digit("minutes", "Minutes left", timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.minutesLeft), separator, digit("seconds", "Seconds left", timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.secondsLeft));
};
// Countdown/useCountdown.ts
import { useCallback, useEffect, useState } from "react";
var hourMs = 1e3 * 60 * 60;
var minuteMs = 1e3 * 60;
var calculateTimeLeft = function calculateTimeLeft(endsAt) {
    var msLeft = Math.max(endsAt - /* @__PURE__ */ new Date().getTime(), 0);
    var hoursLeft = Math.floor(msLeft / hourMs);
    var minutesLeft = Math.floor(msLeft % hourMs / minuteMs);
    var secondsLeft = Math.floor(msLeft % minuteMs / 1e3);
    return {
        hoursLeft: hoursLeft.toString().padStart(2, "0"),
        minutesLeft: minutesLeft.toString().padStart(2, "0"),
        secondsLeft: secondsLeft.toString().padStart(2, "0")
    };
};
var useCountdown = function useCountdown(param) {
    var endsAt = param.endsAt, startsAt = param.startsAt;
    var _useState = _sliced_to_array(useState(null), 2), timeLeft = _useState[0], setTimeLeft = _useState[1];
    var tick = useCallback(function() {
        var now = /* @__PURE__ */ new Date().getTime();
        var hasStarted = startsAt === void 0 || startsAt <= now;
        setTimeLeft(hasStarted && now < endsAt ? calculateTimeLeft(endsAt) : null);
    }, [
        endsAt,
        startsAt
    ]);
    useEffect(function() {
        tick();
        var timer = setInterval(tick, 500);
        return function() {
            return clearInterval(timer);
        };
    }, [
        tick
    ]);
    var isActive = timeLeft !== null;
    return {
        isActive: isActive,
        timeLeft: timeLeft
    };
};
// DummyHidden/index.tsx
import React2 from "react";
var DummyHidden = function DummyHidden() {
    return /* @__PURE__ */ React2.createElement("div", {
        "aria-hidden": "true",
        className: "hidden text-sm text-light-body",
        style: {
            display: "none"
        }
    }, "femtasy");
};
// Modal/index.tsx
import React3, { useState as useState2 } from "react";
var Modal = function Modal(param) {
    var children = param.children, closeIcon = param.closeIcon, trackingName = param.trackingName, trackContentInteraction = param.trackContentInteraction, onClose = param.onClose;
    var _useState2 = _sliced_to_array(useState2(false), 2), hidden = _useState2[0], setHidden = _useState2[1];
    var hide = function hide() {
        setHidden(true);
    };
    if (hidden) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement("div", {
        className: "modal bg-lighter p-8 w-full min-h-min"
    }, /* @__PURE__ */ React3.createElement("div", {
        className: "flex justify-end cursor-pointer",
        onClick: function onClick() {
            if (trackingName) {
                trackContentInteraction("close", "modals", trackingName);
            }
            hide();
            onClose && onClose();
        }
    }, closeIcon && closeIcon), children);
};
export { CountdownDigits, DummyHidden, Modal, calculateTimeLeft, useCountdown }; /*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/ 
